/**
 * Suppress native image drag so a click-and-slight-move doesn't start an
 * OS/browser drag ghost instead of registering as a click (#23509).
 * WebkitUserDrag covers Chrome/Safari; Firefox ignores it and needs a
 * `draggable={false}` attribute on the `<img>` itself as well (mirrors
 * FileViewerGallery's #21264 fix).
 */
export const noDragStyles = {
  WebkitUserDrag: 'none',
  userSelect: 'none'
} as const

export default noDragStyles
